import cx from "classnames";
import React from "react";
export var SpaceBetween = function (_a) {
    var children = _a.children, className = _a.className, divider = _a.divider;
    var kids = children;
    if (children && children.type === React.Fragment) {
        kids = children.props.children;
    }
    if (Array.isArray(kids)) {
        kids = kids.filter(Boolean);
    }
    var dividerComponent = null;
    if (React.isValidElement(divider)) {
        dividerComponent = React.cloneElement(divider, {
            className: cx(divider.props.className, className),
        });
    }
    return (React.createElement(React.Fragment, null, React.Children.map(kids, function (child, i) {
        var kid = child;
        if (i !== 0 && React.isValidElement(child)) {
            kid = React.cloneElement(child, {
                className: cx(child.props.className, className),
            });
        }
        if (dividerComponent && i !== 0) {
            return [dividerComponent, kid];
        }
        return kid;
    })));
};
